import router from '@/router'

import store from '@/store'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/tool/common'

NProgress.configure({
	showSpinner: true
})

const whiteList = ['/login','/forget','/register','/auto', '/404']

router.beforeEach((to, from, next) => {
    NProgress.start()
    if(to.meta.title) {
        document.title = HostConfig.Sitename + '-' + to.meta.title
    }else {
        document.title = HostConfig.Sitename
    }
    
    let token = getToken()
    if(token) {
        if (['/login','/forget','/register'].includes(to.path)) {
            next({ path: '/' })
            NProgress.done()
        }else {
            if(['/auto'].includes(to.path)) {
                next()
                return
            }
            store.dispatch("GetUserInfo").then((userinfo) => {
                if(store.state.menus.length === 0) {
                    store.dispatch('GenerateRoutes').then(Routes => {
                        // Routes.forEach(v => {
                        //     router.addRoute(v)
                        // })
                        next({ ...to, replace: true })
                    })
                }else {
                    next()
                }
            })
        }
    }else {
        if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`)
			NProgress.done();
		}
    }
})

router.afterEach(() => {
	NProgress.done()
})